/**
 * Clear stale tldraw menu state (e.g. an open context menu) without moving focus.
 */
export function clearWhiteboardOpenMenus(editor) {
    if (!editor) return;
    editor.menus?.clearOpenMenus?.();
}

/**
 * Restore tldraw canvas interactivity after a MUI overlay (e.g. Entity info drawer) closes.
 * Clears stale open-menu state that blocks right-click context menus via MenuClickCapture.
 */
export function restoreWhiteboardEditorFocus(editor) {
    if (!editor) return;

    clearWhiteboardOpenMenus(editor);

    if (editor.getCurrentToolId?.() !== 'select') {
        editor.setCurrentTool?.('select');
    }

    editor.focus?.();
}
